module.exports = __webpack_public_path__ + "img/title.1abb27bc.png";